export default __webpack_public_path__ + "static/media/518888__ash-rez__1up-video-game.b98b3239.mp3";